<template>
  <reusable-dialog v-model="isVisibleDialog">
    <h3
      slot="title"
      :class="$style.title"
      v-text="$t('timezone.automatic.detection.title')"
    ></h3>

    <div :class="$style.content">
      <div
        :class="$style.timer"
        v-text="browserTimer"
      ></div>
      <div :class="$style.information">
        <div
          v-m-b="5"
          :class="$style.label"
          v-text="`${$t(browserWeekDay)}, ${browserDate}`"
        ></div>
        <div
          :class="$style.description"
          v-text="browserOffsetTimeWithArea"
        ></div>
      </div>
    </div>

    <simple-button
      slot="submit"
      variant="primary"
      @click="handleSubmit"
    >
      {{ $t('timezone.automatic.detection.submit') }}
    </simple-button>

    <simple-button
      slot="cancel"
      variant="transparent"
      @click="isVisibleDialog = false"
    >
      {{ $t('timezone.automatic.detection.cancel') }}
    </simple-button>
  </reusable-dialog>
</template>

<script>
import axios from 'lib/utils/axios';
import moment, { getDatetimeWithTimezone } from 'lib/utils/date';
import { getBrowserTimezone } from 'services/helpers/browser';

import getTimezoneByCode from 'api/requests/timezone/getTimezoneByCode';

import SimpleButton from 'molecules/common/SimpleButton';

import { TIME_FORMAT, OFFSET_TIME_FORMAT } from 'definitions/dates';
import { DAYS_OF_WEEK_MAP } from 'definitions/datepicker';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'TimezoneAutomaticDetectionDialog',
  components: {
    SimpleButton,
  },
  created() {
    EVENT_BUS.$on('EVENT_SHOW_TIMEZONE_AUTOMATIC_DETECTION', () => {
      this.isVisibleDialog = true;
    });
  },
  data() {
    return {
      isVisibleDialog: false,
      browserTimer: null,
      browserTimerIntervalId: null,

      browserTimezone: getBrowserTimezone(),
    };
  },
  computed: {
    browserDate() {
      return getDatetimeWithTimezone(new Date, this.browserTimezone.name)
        .format('DD.MM.YY');
    },
    browserOffsetTimeWithArea() {
      const offsetTimeToUTC = getDatetimeWithTimezone(new Date, this.browserTimezone.name)
        .format(OFFSET_TIME_FORMAT);

      const slashSymbolIndex = this.browserTimezone.name.indexOf('/');
      const timezoneArea = this.browserTimezone.name.slice(slashSymbolIndex + 1);

      return `UTC ${offsetTimeToUTC} / ${timezoneArea}`;
    },
    browserWeekDay() {
      return DAYS_OF_WEEK_MAP[moment().isoWeekday()];
    },
  },
  watch: {
    isVisibleDialog: {
      handler(val) {
        if (!val) {
          clearInterval(this.browserTimerIntervalId);
          return;
        }

        this.browserTimerIntervalId = setInterval(this.updateBrowserTimer, 1000);
        this.updateBrowserTimer();
      },
    },
  },
  methods: {
    updateBrowserTimer() {
      this.browserTimer = getDatetimeWithTimezone(new Date, this.browserTimezone.name)
        .format(TIME_FORMAT);
    },
    async handleSubmit() {
      try {
        const { data } = await getTimezoneByCode(axios, this.browserTimezone.name);

        this.$emit('change', data);
      } catch (error) {
        console.log(error);

        this.$alert({
          type: 'warning',
          text: 'something.wrong',
        });
      } finally {
        this.isVisibleDialog = false;
      }
    },
  },
};
</script>

<style lang="sass" module>
  .title
    text-align: center

    +respond-to('small')
      text-align: left

  .content
    +flexbox
    +flex-direction(column)
    +align-items(center)

    +respond-to('small')
      +flex-direction(row)

  .timer
    +size(240px, auto)
    +font-type('medium', 48, 60)
    flex: none
    color: var(--color-white)
    text-align: center
    margin-bottom: 15px
    padding: 15px 25px
    background: linear-gradient(249.76deg, #24A84D -8.32%, #068ACC 108.85%), rgba(255, 255, 255, 0.5)
    border-radius: 5px

    +respond-to('small')
      margin-bottom: 0

  .information
    text-align: center
    overflow: hidden

    +respond-to('small')
      text-align: left
      padding-left: 15px

  .label
    +font-type('medium', 16, 20)
    color: var(--color-white)

  .description
    +text-ellipsis
    +font-type('medium', 12, 16)
    color: var(--color-grey-5)
</style>
